export enum Routes {
  LOGIN = '/login',
  GUEST_LOCATIONS = '/app/guest-locations',
}
